import Client from '../axios-client';

const resource = '/application/applications';

export default {
  getApplicationForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  getApplication(applicationId) {
    return Client.get(`${resource}/${applicationId}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  remove(applicationId, version) {
    return Client.delete(`${resource}/${applicationId}?version=${version}`);
  },
  changeApplicationData(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/change-data`, payload);
  },


  changeApplicationAttributes(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/change-attributes`, payload);
  },


  changeApplicationStatus(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/change-status`, payload);
  },
  writeEmployeeComments(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/employee-comment`, payload);
  },
  writeManagementComments(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/management-comment`, payload);
  },
  requiredMedicalDecision(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/medical-decision-required`, payload);
  },
  changeMedicalDecisionStatus(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/medical-decision`, payload);
  },
  getPDF: function(applicationId, base64 = true) {
    const config = base64
      ? {} // JSON
      : { responseType: 'blob' }; // binarnie
    return Client.get(`${resource}/${applicationId}/pdf?base64=${base64}`, config)
  },
  getProcessingApplications(beneficiaryId) {
    return Client.get(`${resource}/processing-applications/${beneficiaryId}`);
  },
  getAvailableTypes(beneficiaryId) {
    return Client.get(`/application/beneficiaries/${beneficiaryId}/available-types`);
  },
  changeSocialSupportAvailability(beneficiaryId, payload) {
    return Client.put(`/application/beneficiaries/${beneficiaryId}/social-support/availability`, payload);
  },
  getApplicationsByType(payload) {
    return Client.post(`${resource}/get-by-type`, payload);
  },
};
